<template>
  <div class="d-flex p-4 flex-wrap viewOffset" width="80%">
    <div v-for="m in sortedModels" :key="m.index">
      <model-card :ticket="m"></model-card>
    </div>
    <h3 v-if="sortedModels.length == 0" class="m-4 fst-italic text-muted">{{
      manageStore.lang("modelView.ticketPlaceholder") }}</h3>
  </div>

</template>

<script setup>
import ModelCard from '@/components/cards/ModelCard.vue';
import { useTicketsStore } from '@/stores/tickets';
import { useManageStore } from '@/stores/manage';
import { computed } from "vue";

const ticketStore = useTicketsStore();
const manageStore = useManageStore();
const models = ticketStore.models;
manageStore.showNavbar = true;

const sortArrayOfObjects = (arr, propertyName, order = 'ascending') => {
  const newArr = arr.slice();
  const sortedArr = newArr.sort((a, b) => {
    if (a[propertyName] < b[propertyName]) {
      return -1;
    }
    if (a[propertyName] > b[propertyName]) {
      return 1;
    }
    return 0;
  });

  if (order === 'descending') {
    return sortedArr.reverse();
  }

  return sortedArr;
};

const sortedModels = computed(() => {
  return sortArrayOfObjects(models, "priority", "descending");
});

</script>

<style scoped>
.viewOffset {
  margin-top: 130px;
}
</style>